function currencyFormatter(value){
    return new Intl.NumberFormat("de-DE", { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(value);
};

function percentFormatter(value, dec = 1){
    return new Intl.NumberFormat("de-DE", { style: 'percent', maximumFractionDigits: dec, minimumFractionDigits: dec }).format(value);
};

function yearFormatter(value){
    if (value === 1) {
    return value + " Jahr"
    } else {
        return value + " Jahre"   
    }
};

export {currencyFormatter, percentFormatter, yearFormatter}